import React from "react";
import classNames from "classnames";

import { Article } from "@/custom-types/Wordpress";
import { categorySlug } from "@/utils/news/categorySlugFinder";

import Chip from "@/components/botanic/Chip";

import NewsFeaturedMedia from "../NewsFeaturedMedia";
import NewsSocialShareBar from "../NewsSocialShareBar";
import AuthorHeader from "./AuthorHeader/AuthorHeader";
import BrandHeader from "./BrandHeader/BrandHeader";

const NewsArticleHeader: React.FC<{
  article: Article;
}> = ({ article }) => {
  const { brand, categories, featuredMedia, isFeatured, link, title } = article;

  return (
    <>
      <div className={classNames({ "mb-lg": !isFeatured })}>
        {categories.length > 0 &&
          categories.map((category) => (
            <Chip
              key={category}
              href={`/news/${categorySlug(category)}`}
              className={classNames("mb-md mr-md", {
                "text-default": isFeatured,
              })}
            >
              {category}
            </Chip>
          ))}
        <h1 className="mb-md" dangerouslySetInnerHTML={{ __html: title }} />
        <div className="md:flex items-end justify-between">
          {brand.name ? (
            <BrandHeader article={article} />
          ) : (
            <AuthorHeader article={article} />
          )}
          <NewsSocialShareBar
            link={link}
            title={title}
            className="mt-md md:mt-none"
          />
        </div>
      </div>
      {!isFeatured && <NewsFeaturedMedia media={featuredMedia} />}
    </>
  );
};

export default NewsArticleHeader;
